var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#FF00FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 17.25H17.25V23.5C17.25 24.1875 16.6875 24.75 16 24.75C15.3125 24.75 14.75 24.1875 14.75 23.5V17.25H8.5C7.8125 17.25 7.25 16.6875 7.25 16C7.25 15.3125 7.8125 14.75 8.5 14.75H14.75V8.5C14.75 7.8125 15.3125 7.25 16 7.25C16.6875 7.25 17.25 7.8125 17.25 8.5V14.75H23.5C24.1875 14.75 24.75 15.3125 24.75 16C24.75 16.6875 24.1875 17.25 23.5 17.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.6a91ec5ebd5c767998fcd78c3b644851.svg";
export { ForwardRef as ReactComponent };